import React from 'react';
import { useNavigate } from 'react-router';
import { useGetMaintenanceStatusQuery } from 'store/services/settings/settingsApi';
import { useIsAdmin } from 'hooks/useIsAdmin';
import './MaintenanceBanner.css';

const MaintenanceBanner: React.FC = () => {
  const navigate = useNavigate();
  const { isAdmin } = useIsAdmin();
  const { data: maintenanceModeData } = useGetMaintenanceStatusQuery(undefined, {
    pollingInterval: 60000, // Check every 60 seconds
  });

  // Only show banner if maintenance mode is active and user is admin
  if (!maintenanceModeData?.maintenanceMode || !isAdmin) {
    return null;
  }

  const handleClick = () => {
    navigate('/admin/dashboard');
  };

  return (
    <div className="maintenance-banner" onClick={handleClick}>
      <div className="maintenance-banner-content">
        <span className="maintenance-banner-icon">⚠️</span>
        <span className="maintenance-banner-text">
          Maintenance Mode Active - Regular users cannot access the site
        </span>
        <span className="maintenance-banner-link">Click to disable</span>
      </div>
    </div>
  );
};

export default MaintenanceBanner;
